<script setup>
import Buttons from '@/components/ui/Buttons.vue';
import ReportCard from '@/components/cards/ReportCard.vue';
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>
<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data?.background_color}` : '',
      data?.spacing?.top ? `section--top-${data.spacing.top}` : '',
      data?.spacing?.bottom ? `section--bottom-${data.spacing.bottom}` : '',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div class="reports">
        <div v-if="data.title || data.description" class="reports__top">
          <h2
            v-if="data.title"
            class="mb-0 reports__title h2 text-center"
            :class="[data?.background_color === 'black' ? 'white' : 'black']"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            v-html="data.title"
          ></h2>
          <div
            v-if="data.description"
            class="mb-0 reports__description body-1-regular text-center"
            :class="[data?.background_color === 'black' ? 'white' : 'black']"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            v-html="data.description"
          ></div>
        </div>
        <div
          v-if="
            data?.items?.length > 0 ||
            (data?.buttons?.length > 0 && data?.buttons[0].title)
          "
          class="reports__bottom"
        >
          <ul
            v-if="data.items && data.items.length > 0 && data.items[0].title"
            class="m-0 p-0 reports__items"
          >
            <li
              v-for="(item, itemIndex) in data.items"
              :key="itemIndex"
              class="m-0 reports__item"
              data-aos="fade-up"
              :data-aos-delay="itemIndex >= 1 ? 100 + 100 * itemIndex : 100"
            >
              <ReportCard
                :title="item.title"
                :url="item.url"
                :date="report.date"
                :theme="data?.background_color"
              />
            </li>
          </ul>
          <Buttons
            v-if="data.buttons && data?.buttons.length > 0"
            class="reports__buttons"
            :buttons="data.buttons"
            :background-color="data?.background_color"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            :buttons-prefix-class="'js-button-reports'"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.reports {
  $parent: &;
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__title {
    margin: 0 auto;
    text-align: center;
    @include media-breakpoint-up(md) {
      width: 66%;
    }
  }
  &__top {
    display: flex;
    flex-direction: column;
    gap: 32px;
    text-align: center;
    @include media-breakpoint-up(sm) {
      gap: 48px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 48);
    }
  }
  &__bottom {
    display: flex;
    flex-direction: column;
    gap: 56px;
    @include media-breakpoint-up(sm) {
      gap: 80px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 80);
    }
  }
  &__items {
    list-style: none;
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
    @include media-breakpoint-up(sm) {
      grid-template-columns: repeat(2, 1fr);
    }
    @include media-breakpoint-up(md) {
      grid-template-columns: repeat(3, 1fr);
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 8);
    }
  }
  &__buttons {
    justify-content: center;
  }
}
</style>
